module.exports = __webpack_public_path__ + "static/5-fac9f442d383c88c454143d75ab7ce29.png";